export default {
  openPositionalModal({
    commit,
    dispatch,
  }) {
    commit('SET_IS_SHOWN', true);
    dispatch('getMenuItemsList');
  },
  closePositionalModal({
    dispatch,
    commit,
  }) {
    commit('SET_IS_SHOWN', false);
    dispatch('resetState', false);
  },
  getMenuItemsList({
    rootGetters,
    commit,
  }) {
    rootGetters['menuGeneral/getRepository'].list()
      .then((response) => {
        commit('SET_MENU_ITEMS_LIST', response);
      });
  },
  setMenuItemsList({ commit }, value) {
    commit('SET_MENU_ITEMS_LIST', value);
  },
  saveMenuItemPositions({
    rootGetters,
    state,
    dispatch,
  }) {
    if (!state.menuItemsList.length) return;
    rootGetters['menuGeneral/getRepository'].sort(
      state.menuItemsList.map((item) => item.id),
    )
      .then(() => {
        dispatch('menuGeneral/table/fetch', null, { root: true });
        dispatch('closePositionalModal');
      });
  },
  resetState({ commit }) {
    commit('SET_MENU_ITEMS_LIST', []);
  },
};
